import React, { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from '../utils/axiosConfig';
import { useAuth } from './AuthContext';

const SalonContext = createContext();

export const SalonProvider = ({ children }) => {
  const { user } = useAuth();

  const { data: mySalons = [], isLoading: loadingSalons } = useQuery({
    queryKey: ['mySalonsContext'],
    queryFn: async () => {
      const res = await axios.get('/salons/my');
      return res.data || [];
    },
    enabled: !!user && (user.role === 'pro' || user.role === 'admin'),
  });

  // RÈGLE MÉTIER : 1 compte PRO = 1 salon
  // On prend toujours le premier salon de la liste (le seul pour un vrai compte PRO)
  const mySalon = mySalons[0] || null;
  const mySalonId = mySalon?._id || null;

  return (
    <SalonContext.Provider value={{
      mySalons,
      mySalon,
      mySalonId,
      // Alias de compatibilité — NE PAS utiliser pour de nouveaux composants
      activeSalonId: mySalonId,
      activeSalon: mySalon,
      loadingSalons
    }}>
      {children}
    </SalonContext.Provider>
  );
};

export const useSalon = () => useContext(SalonContext);

